import React from "react";
import { Alert } from "antd";
import PropTypes from "prop-types";
import { SERVER_ERROR_MESSAGES, DISPLAY_ERROR_MESSAGES } from "../constants/errorMessages";

function ShowError({ error, ...props }) {
  if (error) {
    props.message = getErrorMessage(error.message, props.message);
    return <Alert {...props} />;
  } else {
    return null;
  }
}
// function can be changed to switch when more conditions need to be processed
const getErrorMessage = (error, message) => {
  return error.includes(SERVER_ERROR_MESSAGES.AUTHENTICATION_FAILURE)
    ? DISPLAY_ERROR_MESSAGES.TRY_AGAIN
    : message;
};

ShowError.propTypes = {
  error: PropTypes.object,
};

ShowError.defaultProps = {
  type: "error",
};

export { ShowError };
